export const enum RootId {
  Images = 'fc33df1327b64cf7bae45c41b6b7e905',
  Illustrations = '384e5c1b7a064df99309799fd7fec65a',
  VectorArtNew = '98285ba8ab164d17a935742bd019e150',
  BasicShapes = 'ab62ca24cd194952aad0707eead0c0f7',
  Videos = '8e256233-1752-4026-9341-54036e7f875e',
  TransparentVideos = '5d54b10e-e5e3-416b-9a2f-9316773f2a5b',
  Ntt = '284c9335-16b4-4b25-9eb1-cdc8d6267d1d',
  Dividers = '9592da06-d9c2-4ff3-ade0-d33852571c75',
}

export const enum AllCategoriesId {
  Patterns = '0fe8fef2d044427d8acb157eca90e6e8',
}
